import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-427abcb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "notification w-80 rounded-md",
  id: "notification"
}
const _hoisted_2 = {
  class: "notification__header font-bold",
  "data-test": "title"
}
const _hoisted_3 = { class: "notification__body font-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notication) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["rounded-md p-4 m-4", _ctx.classAlert[notication.type as TypeOfNotification]]),
        key: notication.id
      }, [
        _createElementVNode("h6", _hoisted_2, _toDisplayString(notication.title), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(notication.text), 1)
      ], 2))
    }), 128))
  ]))
}